export default {
  name: 'Bathroom',
  id: 'Bathroom',
  data: [
    // {
    //   title: 'Hot water is painful to your skin.',
    //   icon1: '/static/svgs/first-floor-bathroom/hot-shower-water.svg',
    //   icon2: '/static/svgs/first-floor-bathroom/hot-shower-water-2.svg',
    //   answers: [
    //     'Turn on cold water to balance out the temperature.',
    //   ],
    //   correctAnswerIndex: 1,
    //   position: {
    //     x: -0.5,
    //     y: 0.2,
    //     z: 0.5
    //   },
    //   completed: false
    // },
    // {
    //   title:
    //     'The shower is draining slowly, causing standing water and the potential for mold growth.',
    //   icon1: '/static/svgs/first-floor-bathroom/slow-drain.svg',
    //   icon2: '/static/svgs/first-floor-bathroom/slow-drain-2.svg',
    //   answers: [
    //     'Pour bleach down the drain.',
    //   ],
    //   correctAnswerIndex: 1,
    //   position: {
    //     x: 0.25,
    //     y: 0.2,
    //     z: 0.9
    //   },
    //   completed: false
    // },
    {
      title: 'A curling iron is left plugged in by the sink.',
      icon1: '/static/svgs/first-floor-bathroom/bathroom-1.svg',
      answers: [
        'Take shelter in an interior, lower-level room away from windows, doors and skylights during a severe storm.',
      ],
      correctAnswerIndex: 0,
      position: {
        x: 0.5,
        y: 0.2,
        z: 1.75
      },
      completed: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/residential/firstFloor/Bathroom.js